import React from 'react'
import { defaultFlags, defaultJsonFlags } from './featureFlagsDefaults'

export const FeatureHubContext = React.createContext({
  loading: false,
  flags: { ...defaultFlags, ...defaultJsonFlags },
  preInitFlags: { ...defaultFlags, ...defaultJsonFlags }
})
